export default __webpack_public_path__ + "static/media/successSend.5ec5827d.png";